import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/take';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Address } from '../../models/address';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { AuthProvider } from '../../providers/auth/auth';
 
@Component({
    selector: 'page-addressfrm',
    templateUrl: 'address_frm.html'
})
export class AddressFrm {

    addressFrm: FormGroup
    action: number
    key: string
    actionDescription: string = 'Unknown Action'

    addressCollectionRef: AngularFirestoreCollection<Address>
    addressRef: AngularFirestoreDocument<Address>
    addressDoc = {} as Address

    submitAttempt: boolean = false

    constructor(public navCtrl: NavController, public navParams: NavParams, public formBuilder: FormBuilder, private afs: AngularFirestore, public authData: AuthProvider){

        this.addressCollectionRef = afs.collection<Address>('addresses')
        this.addressRef = afs.doc<Address>('addresses/' + navParams.get('key'))
        this.buildForm()

        this.action = navParams.get('action')
        if (this.action == 1){
            this.actionDescription = 'Insert'
        } else {
            if (this.action == 2){
                this.actionDescription = 'Change'
            } else {
                if (this.action == 3){
                    this.actionDescription = 'Delete'
                }
            }
            this.addressRef.valueChanges().take(1).subscribe(val => {
                this.addressDoc = val
                this.buildForm()
            })
        }
    }

    buildForm(){
        this.addressFrm = this.formBuilder.group({
            name: [this.addressDoc.name, Validators.required],
            street: [this.addressDoc.street],
            house_nr: [this.addressDoc.house_nr, Validators.required],
            house_nr_addition: [this.addressDoc.house_nr_addition],
            postcode: [this.addressDoc.postcode, Validators.compose([Validators.required, Validators.maxLength(6), Validators.pattern('[0-9]{4}[a-zA-Z]{2}')]) ],
            city: [this.addressDoc.city],
            remarks: [this.addressDoc.remarks]
        })
    }

    save(){
        this.submitAttempt = true
        if ((this.action < 3) && (!this.addressFrm.valid)) return
        this.addressFrm.value["uid"] = this.authData.authState.uid
        this.addressFrm.value["code"] = this.addressFrm.value.name.toUpperCase() //trigger too slow...
        if (this.action == 1){
            this.addressCollectionRef.add(this.addressFrm.value)
        } else {
            if (this.action == 2){
                this.addressRef.update(this.addressFrm.value)
            } else {
                if (this.action == 3){
                    this.addressRef.delete()
                }
            }
        }
        this.navCtrl.pop().then(() => this.navParams.get('resolve')(this.addressFrm.value.name))
    }

}



// WEBPACK FOOTER //
// ./src/pages/address/address_frm.ts